/* 🤖 this file was generated by svg-to-ts */
export const matIconAlignVerticalBottom: {
  name: 'align-vertical-bottom';
  data: string;
} = {
  name: 'align-vertical-bottom',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z"/></svg>`
};
